import React, { useContext } from "react";
import { LanguageContext, text } from "../../../container/language";

const Image = ({ data }) => {
  if (!data.image) {
    return null
  }
  
  const {
    image: { url },
    description,
  } = data;
  const { userLanguage } = useContext(LanguageContext);

  return (
    <div className="text">
      <p>
        <img src={`https://admin.magjistratura.edu.al${url}`} caption="false" />
      </p>
      <p>
        <small>
          <font>{text(description, userLanguage)}</font>
        </small>
      </p>
    </div>
  );
};

export default Image;
